import Price from "../../Util/Price";
import RactiveComponentPlugin from "auto-widget-framework/src/Plugin/RactiveComponent/RactiveComponentPlugin";
import RactiveComponentPluginDefinition from "auto-widget-framework/src/Plugin/RactiveComponent/RactiveComponentPluginDefinition";
const Ractive = require("ractive");

export default class PriceComponent extends RactiveComponentPlugin {

  /**
   * @inheritDoc
   */
  getElementName() {
    return "price";
  }

  /**
   * @inheritDoc
   */
  getComponent() {
    return Ractive.extend({
      template: "{{ formattedPrice }}",
      computed: {
        formattedPrice: function () {
          try {
            return this.data.formattedPrice = Price.format(
              this.get("price"),
              this.get("currency"),
              this.get("format")
            );

          } catch (err) {
            console.error("Failed rendering price.");
            console.error(err);
            return "-";
          }
        }
      }
    });
  }

}

export const PriceComponentPluginDefintion = new RactiveComponentPluginDefinition({
  id: "price_component",
  class: PriceComponent
});
